import { apiFetch } from '../authentication/authUtils';
import { getResponseErrorTitle } from '../shared/apiUtils';

export interface ToolAnnotations {
    title: string;
    openWorldHint: boolean;
    destructiveHint: boolean;
    idempotentHint: boolean;
    readOnlyHint: boolean;
}

export interface Tool {
    name: string;
    description: string;
    annotations: ToolAnnotations;
}

export async function getTools(connectorId: string): Promise<Tool[]> {
    const response = await apiFetch(`/connector/${connectorId}/tool`);

    if (!response.ok) {
        throw new Error(await getResponseErrorTitle(response));
    }

    return response.json() as Promise<Tool[]>;
}
